/* Verolae · FAQ — accordion behaviour ported from the homepage FAQ section script.
   One answer open at a time (unless data-allow-multiple="true"); panels animate via
   max-height and are re-measured on resize. Each instance is initialised once. */
(function () {
  'use strict';

  function initFaq(section) {
    if (!section || section.dataset.verolaeFaqReady === 'true') return;
    section.dataset.verolaeFaqReady = 'true';

    var allowMultiple = section.getAttribute('data-allow-multiple') === 'true';
    var questions = Array.prototype.slice.call(section.querySelectorAll('.mb-faq__question'));

    function answerFor(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }

    function openItem(btn) {
      var answer = answerFor(btn);
      if (!answer) return;
      btn.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    function closeItem(btn) {
      var answer = answerFor(btn);
      if (!answer) return;
      btn.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0';
    }

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (!allowMultiple) {
          questions.forEach(function (other) {
            if (other !== btn) closeItem(other);
          });
        }

        if (isOpen) {
          closeItem(btn);
        } else {
          openItem(btn);
        }
      });
    });

    /* Recalculate open panels on resize (font reflow can change height) */
    window.addEventListener('resize', function () {
      questions.forEach(function (btn) {
        if (btn.getAttribute('aria-expanded') === 'true') {
          var answer = answerFor(btn);
          if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-verolae-faq]'), initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: initialise re-rendered sections and reveal the selected block */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest ? event.target.closest('.mb-faq__item') : null;
    if (!item || !item.closest('[data-verolae-faq]')) return;
    var btn = item.querySelector('.mb-faq__question');
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  });
})();
